import { Box, Grid, GridItem, Heading, Link, SimpleGrid, Text } from "@chakra-ui/react";
import React from "react";
import parser from "html-react-parser";

interface ImageType {
    link?: string;
    img?: string;
    title?: string;
    subtitle?: string;
}

const MediaBlock = ({ page, block }) => {
    let firstImage: ImageType = {};
    let secondImage: ImageType = {};
    let thirdImage: ImageType = {};

    if (block.entry.images) {
        firstImage = block.entry.images[0];
        if (block.entry.images[1]) {
            secondImage = block.entry.images[1];
        }
        if (block.entry.images[2]) {
            thirdImage = block.entry.images[2];
        }
    }

    return (
        <Box className="category-wrapper" pt={10} mr={{ base: 10, md: 0 }}>
            {block.title && block.title != '' && block.entry ? (
            <Heading
                as={'h2'}
                fontFamily="american"
                fontWeight={600}
                fontSize={{ base: '3xl', sm: '4xl', md: '6xl' }}
                color="rgb(20, 59, 73)"
                lineHeight={'100%'}
                mt={{ base: 20, md: 20 }}
                mb={10}>
                <Text as={'div'} fontFamily="brush" fontWeight={500}
                    fontSize={{ base: '6rem', md: '8rem' }} color="rgb(20, 59, 73)" display="inline-block">
                    Bellefonte
                </Text>
                {' '} {block.title}
            </Heading>
            ) : null}
            <Box mb={10} ml={10}>
                <SimpleGrid columns={{ base: 1, md: 2 }}>
                    <Box pt={5} pr={{ base: 0, md: 5}} mb={{ base: 10, md: 0 }}>
                        <Link href={firstImage.link} _hover={{ opacity: 0.8 }}>
                            <Box backgroundImage={`url(${firstImage.img})`} backgroundPosition="center center" backgroundSize="cover" minHeight="250px" position="relative" borderRadius={10}>
                                <Heading textAlign="left" position="absolute" bottom="10px" left="20px" color="white" textShadow="0px 0px 5px #000" lineHeight="1em">{firstImage.title}</Heading>
                                <Text fontSize="2xl" textAlign="left" position="absolute" bottom="10px" left="20px" color="white">{firstImage.subtitle}</Text>
                            </Box>
                        </Link>
                        <Grid templateColumns='repeat(5, 1fr)'>
                            <GridItem colSpan={3}>
                                <Link href={secondImage.link} _hover={{ opacity: 0.8 }}>
                                    <Box pt={5} pr={5}>
                                        <Box backgroundImage={`url(${secondImage.img})`} backgroundPosition="center center" backgroundSize="cover" minHeight="250px" position="relative" borderRadius={10}>
                                            <Heading textAlign="left" position="absolute" bottom="10px" left="20px" color="white" textShadow="0px 0px 5px #000" lineHeight="1em">{secondImage.title}</Heading>
                                            <Text fontSize="2xl" textAlign="left" position="absolute" bottom="10px" left="20px" color="white">{secondImage.subtitle}</Text>
                                        </Box>
                                    </Box>
                                </Link>
                            </GridItem>
                            <GridItem colSpan={2}>
                                <Link href={thirdImage.link} _hover={{ opacity: 0.8 }}>
                                    <Box pt={5}>
                                        <Box backgroundImage={`url(${thirdImage.img})`} backgroundPosition="center center" backgroundSize="cover" minHeight="250px" position="relative" borderRadius={10}>
                                            <Heading textAlign="left" position="absolute" bottom="10px" left="20px" color="white" textShadow="0px 0px 5px #000" lineHeight="1em">{thirdImage.title}</Heading>
                                            <Text fontSize="2xl" textAlign="left" position="absolute" bottom="10px" left="20px" color="white">{thirdImage.subtitle}</Text>
                                        </Box>
                                    </Box>
                                </Link>
                            </GridItem>
                        </Grid>
                    </Box>
                    <Box>
                        {block.entry.embed != null ? (
                            <Box backgroundImage={`url(${page.header_image_url})`} backgroundPosition="center center" backgroundSize="cover" minHeight="560px" borderRadius={10}>
                                {parser(block.entry.embed)}
                            </Box>
                        ) : null}
                    </Box>
                </SimpleGrid>
            </Box>
        </Box>
    )
};

export default MediaBlock;